import React from 'react';
import { Icon } from '../../../components';
import Theme from '../../../theme';

export const HomeOutlineIcon = ({
  color = Theme.CHARCOAL,
  size = 25,
  style,
}) => (
  <Icon
    name='ios-home-outline'
    size={size}
    color={color}
    style={style}
  />
);
